import * as Sentry from '@sentry/react';
export function isCompletedAuth(state) {
    const { authInfo, accessToken } = state;
    if (!authInfo || !accessToken) {
        return false;
    }
    try {
        const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));
        const isMFAEnabled = 'mfa_finished' in tokenPayload;
        const isMFAFinished = tokenPayload.mfa_finished === 'True';
        return !isMFAEnabled || isMFAFinished;
    }
    catch (error) {
        Sentry.captureException(error);
        return false;
    }
}
